<script setup>
import {computed, onMounted, ref} from "vue";
import { useStore } from 'vuex'

import BaseModal from "../../global/modals/BaseModal.vue";
import TextInput from "../../global/forms/TextInput.vue";
import DefaultButton from "../../global/buttons/DefaultButton.vue";

const store = useStore();
const getSharedWith = async() => await store.dispatch('agencyMarketplace/sharedWith');

onMounted(async () => {
  await getSharedWith();
});

const emit = defineEmits(['modal:close'])

// IMPORTANT NOTE: share code is organisation's uuid from the database
const shareCode = ref(null);
const sharingInProgress = ref(false);
const revokingInProgress = ref(false);

const sharedWith = computed(() => store.getters["agencyMarketplace/sharedWith"]);
const sharingErrors = computed(() => store.getters["agencyMarketplace/sharingErrors"]);

const shareWebsite = async (shareCode) => {
  sharingInProgress.value = true;
  await store.dispatch('agencyMarketplace/shareWebsite', {shareCode});
  sharingInProgress.value = false;
}

const revokeAccess = async (shareCode) => {
  revokingInProgress.value = true;
  await store.dispatch('agencyMarketplace/revokeWebsiteAccess', {
    shareCode
  });
  revokingInProgress.value = false;
}

const close = () => {
  shareCode.value = null
  emit('modal:close', true)
}

</script>

<template>
  <div>
    <BaseModal
      @close="close"
    >
      <template #heading>
        <div class="d-flex shareIcon">
          <i class="far fa-share-alt" />
          <div class="ml-3">
            Share website
          </div>
        </div>
      </template>
      <div class="d-flex flex-column">
        <div>Please provide the share code from the organisation you wish to share your website with.</div>
        <div class="share-code-header my-2">
          Organisation code
        </div>
        <TextInput
          v-model="shareCode"
          :class="{'border-danger': sharingErrors}"
        />
        <div
          v-if="sharingErrors"
          class="text-danger"
        >
          {{ sharingErrors }}
        </div>
        <DefaultButton
          :disabled="sharingInProgress"
          class="share-button mx-auto my-2"
          size="md"
          @click="shareWebsite(shareCode)"
        >
          Share Access
        </DefaultButton>
      </div>
      <table class="table">
        <thead>
          <tr>
            <th scope="col">
              Organisation
            </th>
            <th scope="col">
              Date shared
            </th>
            <th scope="col" />
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="organisation in sharedWith"
            :key="organisation.uuid"
          >
            <td>
              <div class="d-flex flex-column">
                <div>{{ organisation.name }}</div>
                <small>{{ organisation.uuid }}</small>
              </div>
            </td>
            <td>{{ organisation.shared_at }}</td>
            <td>
              <DefaultButton
                :disabled="revokingInProgress"
                size="md"
                button-style="danger"
                @click="revokeAccess(organisation.uuid)"
              >
                Revoke access
              </DefaultButton>
            </td>
          </tr>
        </tbody>
      </table>
    </BaseModal>
  </div>
</template>

<style scoped>
.share-button {
  width: 143px;
}

.share-code-header {
  color: black;
  font-weight: bold;
}

.shareIcon {
  align-items: baseline !important;
}
</style>
